// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgClock24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M8 4.5C8.27614 4.5 8.5 4.72386 8.5 5V7.732L10.2774 8.91731C10.4862 9.05656 10.5565 9.32578 10.4525 9.5462L10.416 9.61068C10.2628 9.84045 9.95241 9.90253 9.72265 9.74936L7.72265 8.41602C7.58355 8.32329 7.5 8.16718 7.5 8V5C7.5 4.72386 7.72386 4.5 8 4.5Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.1416 2C11.4553 2 14.1416 4.68629 14.1416 8C14.1416 11.3137 11.4553 14 8.1416 14C4.82789 14 2.1416 11.3137 2.1416 8C2.1416 4.68629 4.82789 2 8.1416 2ZM8.1416 3C5.38018 3 3.1416 5.23858 3.1416 8C3.1416 10.7614 5.38018 13 8.1416 13C10.903 13 13.1416 10.7614 13.1416 8C13.1416 5.23858 10.903 3 8.1416 3Z"
				/>
			</Svg>
		);
	}
);
SvgClock24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgClock24;
